/**
 * DOCUMENTATION: https://dev.azure.com/iadx/iA%20Digital%20Experience/_wiki/wikis/iA-Digital-Experience.wiki/89/Utilisation-du-Data-Layer-front-end
 */

__cw__define(['jquery'], function ($) {
  // eslint-disable-next-line
  window.dataLayer = window.dataLayer || [];
  var _autoTrackStartDate = null;
  var _environnement;
  var _pageId;

  /*********************************** INIT AND SHARED METHODS *******************************************/

  var initAutoTracking = function initAutoTracking(environnement, formType, pageId) {
    try {
      _environnement = environnement;
      _pageId = pageId.replace('{', '').replace('}', '');
      initFormTracking(formType);
      _autoTrackStartDate = Date.now();
    } catch (ex) {
      consoleError("An unhandled exception occured during Data Layer initialization: " + ex.toString());
    }
  };
  function enableLogging() {
    return _environnement != 'prod';
  }
  function consoleInfo(message) {
    if (enableLogging()) {
      console.info(message);
    }
  }
  function consoleWarn(message) {
    if (enableLogging()) {
      console.warn(message);
    }
  }
  function consoleError(message) {
    if (enableLogging()) {
      console.error(message);
    }
  }
  function debounce(func, timeout) {
    var _this = this;
    if (timeout === void 0) {
      timeout = 300;
    }
    var timer;
    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      clearTimeout(timer);
      timer = setTimeout(function () {
        func.apply(_this, args);
      }, timeout);
    };
  }

  /******************************** Form Tracking ***************************************/

  var MOUSE_FLOW_FORM_NAME_PREFIX = 'mf_feedback';
  var FORM_COMPLETE_DELAY_MS = 500;
  var _trackedForms = {};
  var getHubSpotFormGuid = function getHubSpotFormGuid(form) {
    var hubSpotProperties = getHubSpotProperties(form);
    return hubSpotProperties ? hubSpotProperties['GA_HSFormGUID'] : null;
  };
  var getHubSpotUserGuid = function getHubSpotUserGuid(form) {
    var hubSpotProperties = getHubSpotProperties(form);
    return hubSpotProperties ? hubSpotProperties['GA_HSUserGUID'] : null;
  };
  function initFormTracking(formType) {
    initSearchFormTracking();
    $('form').each(function () {
      if ($(this).attr('data-utag-ignore') == 'true') {
        return;
      }
      trackForm(this, formType);
    });
    var debouncedRescan = debounce(function () {
      observer.disconnect();
      initFormTracking(formType);
    }, 1000);
    var observer = new MutationObserver(debouncedRescan);
    var config = {
      childList: true,
      subtree: true,
      attributeFilter: ['style']
    };
    var targetNode = document.body;
    observer.observe(targetNode, config);
  }
  function initFormControlTracking(formControlElement) {
    var formName = getFormNameFromControlElement(formControlElement);
    var formControlName = getFormControlName(formControlElement);
    var formControlInstanceId = getFormControlInstanceId(formControlElement);
    var isTracked = _trackedForms[formName].formControls[formControlName] && _trackedForms[formName].formControls[formControlName].instances[formControlInstanceId] && _trackedForms[formName].formControls[formControlName].instances[formControlInstanceId].isTracked;
    if (!formName || !formControlName || !formControlInstanceId) {
      return;
    }
    if ($(formControlElement).attr('type') == 'hidden' && !isTracked) {
      enableHiddenInputChangeTracking(formControlElement);
    } else if ($(formControlElement).hasClass('selectric')) {
      $(formControlElement).off('selectric-change', trackFormControlInteraction).on('selectric-change', trackFormControlInteraction);
    }
    $(formControlElement).off('change', trackFormControlInteraction).on('change', trackFormControlInteraction);
    if (_trackedForms[formName].formControls[formControlName] == undefined) {
      _trackedForms[formName].formControls[formControlName] = {
        instances: {}
      };
    }
    _trackedForms[formName].formControls[formControlName].instances[formControlInstanceId] = {
      isTracked: true
    };
  }
  function initSearchFormTracking() {
    if (_autoTrackStartDate != null) {
      return;
    }
    $('.header-form-recherche .bouton-recherche, .CoveoSearchButton').on('click', function () {
      trackFormComplete($(this).closest('form'));
    });
  }
  function trackForm(form, formType) {
    var formName = getFormName(form);
    if (formName == null) {
      return;
    } else if (formName.startsWith(MOUSE_FLOW_FORM_NAME_PREFIX)) {
      return;
    }
    if (!(_trackedForms[formName] && _trackedForms[formName].tracked)) {
      if (getFormType(form) == 'unknown') {
        if (formType != null && formType != '') {
          $(form).attr('data-utag-form-type', formType);
        } else {
          consoleWarn("No form type provided for form \"" + formName + "\". Please define the \"data-utag-form-type\" attribute on the form or set the tag in Sitecore for page \"" + _pageId + "\".");
        }
      }
      if ($(form).attr('data-utag-ensure-visible') == 'true' && !$(form).is(':visible')) {
        return;
      }
      _trackedForms[formName] = {
        tracked: true,
        formControls: {}
      };
      if ($(form).attr('data-utag-ignore-form-view') != 'true') {
        trackFormInteraction(getFormName(form), getFormType(form), {
          'form_guid': getHubSpotFormGuid(form),
          'form_user_guid': getHubSpotUserGuid(form),
          'form_value': getFormValue(form, 'form_view'),
          'form_attribute': getFormAttribute(form)
        }, null, 'form_view');
      }
    }
    $(form).find('select, input[type=text], input[type=number], input[type=range], input[type=checkbox], input[type=radio], input[type=tel], input[type=email], input[type=search], input[type=password], input[type=hidden][data-utag-force-track=true], textarea').each(function () {
      initFormControlTracking(this);
    });
  }
  function trackFormBegin(formControlElement) {
    var $form = $(formControlElement).closest('form');
    if ($form == null) {
      return false;
    }
    var formName = getFormName($form);
    if (_autoTrackStartDate && Date.now() - _autoTrackStartDate < 1000) {
      return false;
    } else if (_trackedForms[formName].trackFormBegin) {
      return true;
    }
    trackFormInteraction(formName, getFormType($form), {
      'form_guid': getHubSpotFormGuid($form),
      'form_user_guid': getHubSpotUserGuid($form),
      'form_value': getFormValue($form, 'form_begin'),
      'form_attribute': getFormAttribute($form)
    }, null, 'form_begin');
    _trackedForms[formName].trackFormBegin = true;
    return true;
  }
  function trackFormComplete(form, callback, options) {
    try {
      var formName = getFormName(form);
      if (_trackedForms[formName] == null) {
        consoleWarn("trackFormComplete() called on untracked form '" + formName + "'.");
        if (callback) callback();
        return;
      } else if (_trackedForms[formName].formCompleteTracked) {
        if (callback) callback();
        return;
      }
      _trackedForms[formName].formCompleteTracked = true;
      trackHubSpotProperties(form);
      if ($(form).attr('data-utag-form-complete-delay') == 'true') {
        window.setTimeout(function () {
          trackFormCompleteImmediately(form, callback, options);
        }, FORM_COMPLETE_DELAY_MS);
      } else {
        trackFormCompleteImmediately(form, callback, options);
      }
    } catch (ex) {
      consoleError("An unhandled exception occured during form complete tracking: " + ex.toString());
    }
  }
  function trackFormCompleteImmediately(form, callback, options) {
    options = options != null ? options : {};
    trackFormInteraction(getFormName(form), getFormType(form), {
      'form_guid': options.form_guid != null ? options.form_guid : getHubSpotFormGuid(form),
      'form_user_guid': options.form_user_guid != null ? options.form_user_guid : getHubSpotUserGuid(form),
      'form_value': options.form_value != null ? options.form_value : getFormValue(form, 'form_complete'),
      'form_metric': options.form_metric != null ? options.form_metric : getFormMetric(form),
      'form_attribute': options.form_attribute != null ? options.form_attribute : getFormAttribute(form)
    }, null, 'form_complete');
    if (callback) {
      callback();
    }
  }
  function trackHubSpotProperties(form) {
    var hubSpotProperties = getHubSpotProperties(form);
    if (hubSpotProperties != null) {
      window.dataLayer.push(hubSpotProperties);
      consoleInfo("HubSpot properties tracked: " + JSON.stringify(hubSpotProperties));
    }
  }
  function trackFormError(form) {
    return;
  }
  function trackFormInteraction(formName, formType, options, _callBack, eventName) {
    var interaction = {
      'form_type': formType,
      'form_name': formName,
      'form_attribute': null,
      'form_value': null,
      'form_metric': null,
      'form_step': null,
      'form_guid': null
    };
    if (options && options.form_value != undefined) interaction['form_value'] = options.form_value;
    if (options && options.form_attribute != undefined) interaction['form_attribute'] = options.form_attribute;
    if (options && options.form_metric != undefined) interaction['form_metric'] = options.form_metric;
    if (options && options.form_step != undefined) interaction['form_step'] = options.form_step;
    if (options && options.form_guid != undefined) interaction['form_guid'] = options.form_guid;
    if (options && options.form_user_guid != undefined) interaction['form_user_guid'] = options.form_user_guid;
    window.dataLayer.push({
      'event': eventName,
      'interaction': interaction
    });
    if (_callBack) {
      _callBack();
    }
    consoleInfo("Form interaction tracked. Event Name: " + eventName + ", Interaction: " + JSON.stringify(interaction) + ".");
  }
  function trackFormStep(formControlElement) {
    var $form = $(formControlElement).closest('form');
    if ($form == null) {
      return false;
    }
    var formName = getFormName($form);
    var formControlName = getFormControlName(formControlElement);
    if (_trackedForms[formName].formControls[formControlName].isStepTracked) {
      return;
    }
    trackFormInteraction(getFormName($form), getFormType($form), {
      'form_step': formControlName,
      'form_guid': getHubSpotFormGuid($form),
      'form_user_guid': getHubSpotUserGuid($form),
      'form_value': getFormValue($form, 'interaction')
    }, null, 'interaction');
    _trackedForms[formName].formControls[formControlName].isStepTracked = true;
  }
  function trackFormControlInteraction() {
    if (!$(this).val()) {
      return;
    }
    if (!trackFormBegin(this)) {
      return;
    }
    trackFormStep(this);
  }
  function enableHiddenInputChangeTracking(element) {
    var observer = new MutationObserver(function (mutations, observer) {
      if (mutations[0].attributeName == 'value') {
        $(element).trigger('change');
      }
    });
    observer.observe(element, {
      attributes: true
    });
  }
  function getHubSpotProperties(form) {
    var dataLayer = $(form).find('input[name=JSonDataLayerValue]').val();
    if (dataLayer == null || dataLayer == '') {
      dataLayer = $("input[data-utag-target-form-name=" + getFormName(form) + "]").val();
    }
    if (dataLayer == null || dataLayer == '') {
      return null;
    }
    return JSON.parse(dataLayer);
  }
  function getFormName(formElement) {
    var formName = $(formElement).attr("data-utag-fname-" + _pageId);
    if (formName == null || formName == '') {
      formName = $(formElement).attr('data-utag-fname');
    }
    if (formName == null || formName == '') {
      formName = $(formElement).attr('name');
    }
    if (formName == null || formName == '') {
      formName = $(formElement).attr('id');
    }
    if (formName == null) {
      return null;
    }
    return formName;
  }
  function getFormNameFromControlElement(formControlElement) {
    var formElement = $(formControlElement).closest('form');
    if (formElement == null) {
      return;
    }
    return getFormName(formElement);
  }
  function getFormType(formElement) {
    var formType = $(formElement).attr('data-utag-form-type');
    if (formType == null) {
      formType = 'unknown';
    }
    return formType;
  }
  function getFormControlName(formControlElement) {
    var formControlName = $(formControlElement).attr('data-utag-form-control-name');
    if (formControlName == null) {
      formControlName = $(formControlElement).attr('name');
    }
    if (formControlName == null) {
      formControlName = $(formControlElement).attr('id');
    }
    if (formControlName == null) {
      consoleWarn('Cannot retrieve name of form control element. Form control must have the "data-utag-form-control-name", "name" or "id" attribute set.');
      return false;
    }
    return formControlName;
  }
  function getFormControlInstanceId(formControlElement) {
    var formControlInstanceId = $(formControlElement).attr('id');
    if (formControlInstanceId == null) {
      formControlInstanceId = getFormControlName(formControlElement);
    }
    return formControlInstanceId;
  }
  function getFormValue(form, eventName) {
    var values = {};
    $(form).find('[data-utag-enable-value-tracking=true]').each(function () {
      if (eventName != 'form_complete' && $(this).attr('data-utag-enable-value-tracking-on-all-events') != 'true') {
        return;
      }
      values[getFormControlName(this)] = getFormControlElementValue(this);
    });
    var validEntries = Object.entries(values).filter(function (entry) {
      return entry[1] != undefined && entry[1] != '';
    });
    if (validEntries.length == 0) {
      return null;
    } else {
      return validEntries.map(function (entry) {
        return entry[0] + "=" + entry[1];
      }).join(';');
    }
  }
  function getFormAttribute(form) {
    var value = null;
    var objAttribute = null;
    if ($(form).attr('data-utag-form-attribute')) {
      value = $(form).attr('data-utag-form-attribute');
      objAttribute = JSON.parse(value);
    }
    return objAttribute;
  }
  function getFormMetric(form) {
    var metric = null;
    $(form).find('[data-utag-form-metric-value=true]').each(function () {
      metric = Number(getFormControlElementValue(this));
    });
    return !isNaN(metric) ? metric : null;
  }
  function getFormControlElementValue(formControlElement) {
    var value = null;
    var source = $(formControlElement).attr('data-utag-enable-value-tracking-source');
    if (source == 'label') {
      value = $(formControlElement).next('label').text().trim().replace('\n', '');
    } else if (formControlElement.tagName.toLowerCase() == 'select') {
      value = $(formControlElement).find('option:selected').text();
    } else if (formControlElement.getAttribute('type') == 'checkbox') {
      value = $(formControlElement).is(':checked');
    } else if (formControlElement.getAttribute('type') == 'radio') {
      value = $('input[name="' + $(formControlElement).attr('name') + '"]:checked').val();
    } else if (formControlElement.getAttribute('type') == 'file') {
      value = $(formControlElement)[0].files.length > 0;
    } else {
      value = $(formControlElement).val();
    }
    if (value != null && typeof value === 'string') {
      value = value.replace(/\s+/g, ' ').trim();
    }
    return value;
  }

  /**************************************** Click Tracking ********************************************/

  var CLICK_LOCATION_MAPPING = {
    'header': ['header', '.nav-secondaire'],
    'footer': ['footer'],
    'pop-up': ['.remodal-wrapper'],
    'overlay': ['.zone-sticky'],
    'dropdown': ['.dropdown-menu', '.dropdown-primary'],
    'carrousel': ['.swiper-slide'] //TODO: mapper la position de carrousel
  };
  var NO_LINK_CLICK_TYPE = {
    'tab': ['.tuile-action', '.commun-element-onglet'],
    'dropdown': ['.titre-accordeon', '.dropdown-toggle', '.dropdown-group', '.selectric-wrapper', '.dropdown-primary'],
    'checkbox': ['.icon-star', '#toggle_favorites']
  };
  function initClickTracking() {
    document.addEventListener('click', function (event) {
      var clickElement = event.target;
      var type = getNoLinkType(clickElement);
      if (type) {
        trackClickInteraction(type, getClickName(clickElement), null, getClickLocation(clickElement), null);
        return;
      }
      var linkElement = clickElement.closest('a');
      type = getLinkType(linkElement);
      if (type) {
        trackClickInteraction(type, getClickName(linkElement), linkElement.getAttribute('href'), getClickLocation(clickElement), null);
      }
    });
    document.addEventListener('change', function (event) {
      var inputElement = event.target;
      if (inputElement.getAttribute('type') == 'checkbox') {
        trackClickInteraction('checkbox', getClickName(inputElement.parentElement), null, getClickLocation(inputElement), null);
      }
    });
  }
  function trackClickInteraction(type, name, destination, location, value, _callBack) {
    var clickData = {
      'click_type': type,
      'click_name': name,
      'click_destination': destination,
      'click_location': location
    };
    if (value) clickData['click_value'] = value;
    window.dataLayer.push({
      'event': 'click_interaction',
      'interaction': clickData
    });
    if (_callBack) {
      _callBack();
    }
  }
  function getNoLinkType(clickElement) {
    var type;
    for (var clickType in NO_LINK_CLICK_TYPE) {
      NO_LINK_CLICK_TYPE[clickType].map(function (mapping) {
        if (clickElement.closest(mapping)) {
          type = clickType;
          consoleInfo('mapping click type to ' + clickType);
        }
      });
    }
    return type;
  }
  function getLinkType(linkElement) {
    if (linkElement) {
      var lien = linkElement.getAttribute('href');
      if (lien.startsWith('mailto:')) {
        return 'mail';
      } else if (lien.startsWith('tel:')) {
        return 'phone_number';
      } else {
        return 'link';
      }
    }
    return;
  }
  function getClickLocation(clickElement) {
    var location = 'body';
    for (var locationMap in CLICK_LOCATION_MAPPING) {
      CLICK_LOCATION_MAPPING[locationMap].map(function (mapping) {
        if (clickElement.closest(mapping)) {
          location = locationMap;
          consoleInfo('mapping click location to ' + locationMap);
        }
      });
    }
    return location;
  }

  // TODO: Ameliorer pour obtenir le text au lieu des icones ou "vide" dependamment d'ou on clique dans l'element
  function getClickName(clickElement) {
    var name = clickElement.innerText;
    if (!name) consoleInfo('No text mapped where the element was clicked.');
    return name;
  }

  /************************************************** Video Tracking *****************************************************************/

  var VIDEO_PROGRESS_TRACK_THRESHOLDS = [25, 50, 75];
  var _trackedVideos = {};
  function initVideoTracking() {
    window.onYouTubeIframeAPIReady = function () {
      $('iframe').each(function () {
        var videoId = this.id;
        if (videoId == null || _trackedVideos[videoId] && !_trackedVideos[videoId].tracked) {
          return;
        }
        // eslint-disable-next-line
        var player = YT.get(videoId);
        if (player == null) {
          // eslint-disable-next-line
          player = new YT.Player(this);
        }
        _trackedVideos[videoId] = {
          player: player,
          progressTresholds: {},
          title: this.title,
          src: this.src
        };
        player.addEventListener('onStateChange', function (event) {
          trackVideoStateChange(videoId, event.data);
        });
        window.setInterval(function () {
          trackVideoProgress(videoId);
        }, 1000);
        _trackedVideos[videoId].tracked = true;
      });
    };
  }
  function trackVideoInteraction(title, duration, progress, link, _callBack, eventName) {
    if (eventName === void 0) {
      eventName = 'video_start';
    }
    var interaction = {
      'video_title': title,
      'video_duration': duration,
      'video_link': link
    };
    if (progress) interaction['video_progress'] = progress;
    window.dataLayer.push({
      'event': eventName,
      'interaction': interaction
    });
    if (_callBack) {
      _callBack();
    }
    consoleInfo("Video interaction tracked. Event Name: " + eventName + ", Interaction: " + JSON.stringify(interaction) + ".");
  }
  function trackVideoStateChange(videoId, state) {
    var player = _trackedVideos[videoId].player;
    if (state == 1 && !_trackedVideos[videoId].trackVideoStart) {
      trackVideoInteraction(player.getVideoData().title, player.getDuration(), null, _trackedVideos[videoId].src, null, 'video_start');
      _trackedVideos[videoId].trackVideoStart = true;
    } else if (state == 0 && !_trackedVideos[videoId].trackVideoCompleted) {
      trackVideoInteraction(player.getVideoData().title, player.getDuration(), 100, _trackedVideos[videoId].src, null, 'video_complete');
      _trackedVideos[videoId].trackVideoCompleted = true;
    }
  }
  function trackVideoProgress(videoId) {
    var player = _trackedVideos[videoId].player;
    var progressPercentage = player.getCurrentTime() / player.getDuration() * 100;
    var newProgressTresholdsReached = VIDEO_PROGRESS_TRACK_THRESHOLDS.filter(function (threshold) {
      return progressPercentage >= threshold && !_trackedVideos[videoId].progressTresholds[threshold];
    });
    newProgressTresholdsReached.forEach(function (threshold) {
      trackVideoInteraction(player.getVideoData().title, player.getDuration(), threshold, _trackedVideos[videoId].src, null, 'video_progress');
      _trackedVideos[videoId].progressTresholds[threshold] = true;
    });
  }

  /************************************************** Misc Tracking *****************************************************************/

  function initScrollDepthTracking() {
    if (_autoTrackStartDate != null) {
      return;
    }
    var hauteurMax = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    var tracking = [{
      pourcentage: '50',
      envoye: false
    }, {
      pourcentage: '90',
      envoye: false
    }];
    document.addEventListener('scroll', function (event) {
      var positionActuel = window.scrollY;
      var pourcentage = Math.round(positionActuel / hauteurMax * 100);
      tracking.map(function (track) {
        if (pourcentage > track.pourcentage && !track.envoye) {
          window.dataLayer.push({
            'event': 'depth_reached',
            'interaction': {
              'scroll_depth': track.pourcentage
            }
          });
          track.envoye = true;
        }
      });
    });
  }
  return {
    getHubSpotUserGuid: getHubSpotUserGuid,
    getHubSpotFormGuid: getHubSpotFormGuid,
    initAutoTracking: initAutoTracking,
    trackFormBegin: trackFormBegin,
    trackFormComplete: trackFormComplete,
    trackFormError: trackFormError,
    trackClickInteraction: trackClickInteraction,
    trackFormInteraction: trackFormInteraction
  };
});